import Quill from 'quill/core';

const findByNode = (node: Node, bubble = false) => Quill.find(node, bubble);

export function findQuillByNode(node: Node) {
  const found = findByNode(node);
  return found instanceof Quill ? found : null;
}

export function findBlotByNode(node: Node, bubble = false) {
  const found = findByNode(node, bubble);
  return found instanceof Quill ? null : found;
}
